<script setup lang="ts">
  import { onMounted, reactive, useTemplateRef } from 'vue'

  const emit = defineEmits(['confirm', 'cancel'])
  const rootEl = useTemplateRef<HTMLDivElement>('rootEl')
  const state = reactive({
    shake: true,
  })

  onMounted(() =>
    rootEl.value?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }),
  )
</script>

<template>
  <div
    class="w-full max-w-2xl rounded-xl border border-red-400/80 bg-purple-500 p-8 text-white shadow-2xl"
    ref="rootEl"
    :class="{ shake: state.shake }"
    @animationend="state.shake = false"
  >
    <div class="flex h-full flex-col">
      <h2 class="font-display mb-2 text-center text-3xl font-bold">Leave the Queue?</h2>

      <!-- Input Section -->
      <div class="my-12 flex flex-col items-center gap-4 text-center">
        <p>Are you sure you'd like to leave the queue?</p>
        <p>You'll be able to re-join the end of the line later.</p>
      </div>

      <!-- Action -->
      <div class="flex justify-center gap-4">
        <button
          @click="emit('confirm')"
          class="cursor-pointer rounded-lg bg-green-400 px-8 py-2 font-bold text-black transition-colors hover:bg-green-500"
        >
          Leave Queue
        </button>

        <button
          @click="emit('cancel')"
          class="bg-base-orange cursor-pointer rounded-lg px-8 py-2 font-bold text-black transition-colors hover:bg-red-500"
        >
          Don't Leave
        </button>
      </div>
    </div>
  </div>
</template>
